import { Grid, Typography, makeStyles, Divider } from '@material-ui/core';
import React from 'react';
import Button from 'components/Button';
import i18n from 'i18n';
import styles from './styles';

const useStyles = makeStyles(styles);

const SimulateRemoteApp = () => {
  const classes = useStyles();
  const [step, setStep] = React.useState(0);

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: '90%' }}
    >
      <Grid className={classes.loadingContainer}>
        <img
          className={classes.loadingAppLogo}
          src="/images/AutoSkyLogoColorido.svg"
          alt="skyone logo"
        />
        {step === 0 ? (
          <>
            <Typography variant="h6" className={classes.titleInstallPlugin}>
              {i18n.t(
                'APPLICATIONS_PAGE.TEST_REMOTE_APP_INSTALL_PLUGIN_TITLE_KEY'
              )}
            </Typography>

            <Typography className={classes.stepsText}>
              {i18n.t(
                'APPLICATIONS_PAGE.TEST_REMOTE_APP_INSTALL_PLUGIN_STEP1_KEY'
              )}
            </Typography>
            <Typography className={classes.stepsText}>
              {i18n.t(
                'APPLICATIONS_PAGE.TEST_REMOTE_APP_INSTALL_PLUGIN_STEP2_KEY'
              )}
            </Typography>
            <Button
              className={classes.buttonDowloadPlugin}
              href="https://skyoneautoskyplugin.s3.amazonaws.com/pacotes/ultima-versao/setup-apl.msi"
              onClick={() => setStep(1)}
            >
              {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_INSTALL_PLUGIN_KEY')}
            </Button>
          </>
        ) : (
          <>
            <Typography variant="h6" className={classes.titleInstallPlugin}>
              {i18n.t(
                'APPLICATIONS_PAGE.TEST_REMOTE_APP_INSTALL_PLUGIN_STEPS_TITLE_KEY'
              )}
            </Typography>
            <img src="/images/InstalacaoPluginChrome.png" alt="" />
            <Divider className={classes.divider} />
            <Grid className={classes.keepGoingContainer}>
              <Typography>
                {i18n.t(
                  'APPLICATIONS_PAGE.TEST_REMOTE_APP_INSTALL_DOWNLOAD_NOT_INIT_KEY'
                )}{' '}
                <a
                  className={classes.spanClickHere}
                  href="https://skyoneautoskyplugin.s3.amazonaws.com/pacotes/ultima-versao/setup-apl.msi"
                >
                  {' '}
                  {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_CLICK_HERE_KEY')}
                </a>{' '}
                {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_INSTALL_MANUAL_KEY')}
              </Typography>
              <Button
                className={classes.buttonKeepGoing}
                onClick={() =>
                  window.open(
                    'https://piloto.skyinone.net/user/',
                    '_blank',
                    'noopener'
                  )
                }
              >
                {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_KEEP_GOING_KEY')}
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default SimulateRemoteApp;
